import React, { useState, useEffect } from "react";
import Images from "../images"; // adjust path if needed
import LazyImg from "./LazyImg";

const WinnerPage = () => {
  const [selectedWinner, setSelectedWinner] = useState(null);
  useEffect(() => {
    document.title = "Winners 2023-24 - MedEngage";
  }, []);
  const [loading, setLoading] = useState(true);

  // ✅ useEffect instead of React.useEffect
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 300); // loader disappears after 2s

    return () => clearTimeout(timer);
  }, []);

  const winners = [
    {
      label: "Research Grant",
      img: Images.Grant,
    },
    {
      label:
        "Scholarship for students doing internships (Aspirational Districts)",
      img: Images.winner1,
    },
    {
      label: "Scholarship for students doing internships",
      img: Images.winner2,
    },
    {
      label:
        "Scholarship for students doing post graduation (Aspirational districts)",
      img: Images.winner3,
    },
    {
      label: "Scholarship for students doing post graduation",
      img: Images.winner4,
    },
    {
      label:
        "Scholarship for students in 1st year of MBBS (Aspirational Districts)",
      img: Images.winner6,
    },
    {
      label: "Scholarship for students in 1st year of MBBS",
      img: Images.winner7,
    },
    {
      label:
        "Scholarship for students in 2nd year of MBBS (Aspirational Districts)",
      img: Images.winner8,
    },
    {
      label: "Scholarship for students in 2nd year of MBBS",
      img: Images.winner9,
    },
    {
      label:
        "Scholarship for students in 3rd year of MBBS (Aspirational Districts)",
      img: Images.winner10,
    },
    {
      label: "Scholarship for students in 3rd year of MBBS",
      img: Images.winner11,
    },
    {
      label:
        "Scholarship for students in 4th year of MBBS (Aspirational Districts)",
      img: Images.winner11,
    },
    {
      label: "Scholarship for students in 4th year of MBBS",
      img: Images.winner12,
    },
  ].map((item) => ({
    ...item,
    key: item.label, // 🔑 now key = label
  }));

  return (
    <>
      {loading && (
        <div
          className="fixed-top w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50"
          style={{ zIndex: 9999 }}
        >
          <div className="custom-spinner"></div>
        </div>
      )}
      <div>
        <section className="winner-page-section">
          <div className="container my-5 winner-page-container">
            <div className="text-center mb-5">
              <h1 className="winner-page-title">Winners 2023-24</h1>
              <p className="winner-page-subtitle">
                Meet the outstanding achievers of the MedEngage Scholarship
                Program 2023-24.
              </p>
            </div>

            {/* Cards */}
            <div className="winner-page-grid">
              {winners.map((w) => (
                <div
                  key={w.key}
                  className="winner-page-card"
                  onClick={() => setSelectedWinner(w)}
                >
                  {w.label}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Modal */}
        {selectedWinner && (
          <div
            className="winner-modal-overlay"
            onClick={() => setSelectedWinner(null)}
          >
            <div
              className="winner-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="winner-modal-close"
                onClick={() => setSelectedWinner(null)}
              >
                <i className="fa fa-times-circle fa-lg text-success"></i>
              </button>
              <h2 className="winner-modal-title">{selectedWinner.label}</h2>
              <LazyImg
                src={selectedWinner.img}
                alt={selectedWinner.label}
                className="winner-modal-image"
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default WinnerPage;
